import { ApiResponse, getRequest, postRequest } from "@/data/apiClient";
import { App } from "@/interfaces/common.interfaces";

export interface Branding {
  kind: string;
  text: string;
  images: string[];
  app?: string;
}

export const getBranding = async (
  app: string | undefined,
  kind: string
): Promise<ApiResponse<Branding>> => getRequest("branding", { app, kind });

export const getBrandingMetadata = async (
  kind: string,
  clientKey: string,
  app: string | undefined
): Promise<ApiResponse<Branding>> =>
  getRequest("brandingMetadata", { kind, clientKey, app });

export const updateBranding = async (
  branding: Branding
): Promise<ApiResponse<Branding>> => postRequest("branding", branding);
